import { FundLogos } from "../../../components/AssetClassLogos/AssetClassImages";

type Props = {
  subjectName?: string;
  assetClass?: AssetClass;
};

export const FundCell = ({ subjectName, assetClass }: Props) => {
  const status = undefined; // TODO when we have statuses

  return (
    <div className="flex items-center gap-3 h-8 overflow-hidden md:max-w-56 lg:max-w-96 xl:max-w-full">
      <div className="w-8 h-8 flex flex-shrink-0 rounded-lg justify-center items-center overflow-hidden">
        <FundLogos assetClass={assetClass} isLoading={false} />
      </div>
      <div className="flex flex-col justify-center gap-1 overflow-hidden">
        <div
          className="text-text/primary body-base-medium truncate"
          title={subjectName}
        >
          {subjectName}
        </div>
      </div>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
      {status ? (
        <div className="px-3 py-1 bg-background/tertiary rounded-full flex items-center">
          <div className="text-text/primary body-small-semibold whitespace-nowrap">
            {status}
          </div>
        </div>
      ) : null}
    </div>
  );
};

import { type AssetClass } from "@vega-api/generated/types/assetClass";
